// @flow
// Types
import type { LineItem, SimpleLineItem } from '../types';

export const toSimpleLineItem = (lineItem: LineItem): SimpleLineItem => ({
  id: lineItem.id,
  name: lineItem.variant.name,
  slug: lineItem.variant.slug,
  quantity: lineItem.quantity,
  images: lineItem.variant.images,
  price: lineItem.price,
  total: lineItem.total,
  unitForQuantity: lineItem.variant.unitForQuantity,
  mixId: lineItem.mixId,
  isFreebie: !!lineItem.isFreebie,
  variantId: lineItem.variantId,
  incrementQuantity: lineItem.variant.incrementQuantity,
  defaultQuantity: lineItem.variant.defaultQuantity,
  // Freebies, gift cards, blends and unavailable products can't have their quantity changed from the cart preview
  canChangeQuantity:
    !lineItem.isFreebie &&
    !lineItem.fixedQuantity &&
    !lineItem.giftCard?.id &&
    !lineItem.mixId &&
    !!lineItem.variant.inStock &&
    !lineItem.variant.discontinued,
});
